// const emoji = [
//     {
//         id:'1',
//         name:'[冷汗]',
//         icon:'emoji-lenghan'
//     },
//     {
//         id:'2',
//         name:'[白眼]',
//         icon:'emoji-baiyan'
//     },
//     {
//         id:'3',
//         name:'[调皮]',
//         icon:'emoji-tiaopi'
//     },
//     {
//         id:'4',
//         name:'[发怒]',
//         icon:'emoji-fanu'
//     },
//     {
//         id:'5',
//         name:'[困]',
//         icon:'emoji-kun'
//     },
//     {
//         id:'6',
//         name:'[泪哭]',
//         icon:'emoji-leiku'
//     },
//     {
//         id:'7',
//         name:'[表情]',
//         icon:'emoji-kaixin'
//     },
//     {
//         id:'8',
//         name:'[微笑]',
//         icon:'emoji-weixiao'
//     },
//     {
//         id:'9',
//         name:'[疑问]',
//         icon:'emoji-yiwen'
//     },
//     {
//         id:'10',
//         name:'[舌头]',
//         icon:'emoji-shetou'
//     },
//     {
//         id:'11',
//         name:'[大笑]',
//         icon:'emoji-daxiao'
//     },
//     {
//         id:'12',
//         name:'[惊讶]',
//         icon:'emoji-jingya'
//     },
//     {
//         id:'13',
//         name:'[惊吓]',
//         icon:'emoji-jingxia'
//     },
//     {
//         id:'14',
//         name:'[感冒]',
//         icon:'emoji-ganmao'
//     },
//     {
//         id:'15',
//         name:'[失望]',
//         icon:'emoji-shiwang'
//     },
//     {
//         id:'16',
//         name:'[无聊]',
//         icon:'emoji-wuliao'
//     },
//     {
//         id:'17',
//         name:'[撅嘴]',
//         icon:'emoji-juezui'
//     },
//     {
//         id:'18',
//         name:'[急眼]',
//         icon:'emoji-jiyan'
//     },
//     {
//         id:'19',
//         name:'[呆]',
//         icon:'emoji-dai'
//     },
//     {
//         id:'20',
//         name:'[流泪]',
//         icon:'emoji-liulei'
//     },
//     {
//         id:'21',
//         name:'[晕]',
//         icon:'emoji-yun'
//     },
//     {
//         id:'22',
//         name:'[色]',
//         icon:'emoji-se'
//     },
//     {
//         id:'23',
//         name:'[天使]',
//         icon:'emoji-tianshi'
//     },
//     {
//         id:'24',
//         name:'[坏笑]',
//         icon:'emoji-huaixiao'
//     },
//     {
//         id:'25',
//         name:'[发呆]',
//         icon:'emoji-fadai'
//     },
//     {
//         id:'26',
//         name:'[吐]',
//         icon:'emoji-tu'
//     },
//     {
//         id:'27',
//         name:'[口罩]',
//         icon:'emoji-kouzhao'
//     },
//     {
//         id:'28',
//         name:'[魔王]',
//         icon:'emoji-mowang'
//     },
//     {
//         id:'29',
//         name:'[睡觉]',
//         icon:'emoji-shuijue'
//     },
//     {
//         id:'30',
//         name:'[哭]',
//         icon:'emoji-ku'
//     },
// ]

var emoji = {
  '[大笑]': 'emoji_00@2x.png',
  '[开心]': 'emoji_01@2x.png',
  '[色]': 'emoji_02@2x.png',
  '[酷]': 'emoji_03@2x.png',
  '[奸笑]': 'emoji_04@2x.png',
  '[亲]': 'emoji_05@2x.png',
  '[伸舌头]': 'emoji_06@2x.png',
  '[眯眼]': 'emoji_07@2x.png',
  '[可爱]': 'emoji_08@2x.png',
  '[鬼脸]': 'emoji_09@2x.png',
  '[偷笑]': 'emoji_10@2x.png',
  '[喜悦]': 'emoji_11@2x.png',
  '[狂喜]': 'emoji_12@2x.png',
  '[惊讶]': 'emoji_13@2x.png',
  '[流泪]': 'emoji_14@2x.png',
  '[流汗]': 'emoji_15@2x.png',
  '[天使]': 'emoji_16@2x.png',
  '[笑哭]': 'emoji_17@2x.png',
  '[尴尬]': 'emoji_18@2x.png',
  '[惊恐]': 'emoji_19@2x.png',
  '[大哭]': 'emoji_20@2x.png',
  '[烦躁]': 'emoji_21@2x.png',
  '[恐怖]': 'emoji_22@2x.png',
  '[两眼冒星]': 'emoji_23@2x.png',
  '[害羞]': 'emoji_24@2x.png',
  '[睡着]': 'emoji_25@2x.png',
  '[冒星]': 'emoji_26@2x.png',
  '[口罩]': 'emoji_27@2x.png',
  '[OK]': 'emoji_28@2x.png',
  '[好吧]': 'emoji_29@2x.png',
  '[鄙视]': 'emoji_30@2x.png',
  '[难受]': 'emoji_31@2x.png',
  '[不屑]': 'emoji_32@2x.png',
  '[不舒服]': 'emoji_33@2x.png',
  '[愤怒]': 'emoji_34@2x.png',
  '[鬼怪]': 'emoji_35@2x.png',
  '[发怒]': 'emoji_36@2x.png',
  '[生气]': 'emoji_37@2x.png',
  '[不高兴]': 'emoji_38@2x.png',
  '[皱眉]': 'emoji_39@2x.png',
  '[心碎]': 'emoji_40@2x.png',
  '[心动]': 'emoji_41@2x.png',
  '[好的]': 'emoji_42@2x.png',
  '[低级]': 'emoji_43@2x.png',
  '[赞]': 'emoji_44@2x.png',
  '[鼓掌]': 'emoji_45@2x.png',
  '[给力]': 'emoji_46@2x.png',
  '[打你]': 'emoji_47@2x.png',
  '[阿弥陀佛]': 'emoji_48@2x.png',
  '[拜拜]': 'emoji_49@2x.png',
  '[第一]': 'emoji_50@2x.png',
  '[拳头]': 'emoji_51@2x.png',
  '[手掌]': 'emoji_52@2x.png',
  '[剪刀]': 'emoji_53@2x.png',
  '[招手]': 'emoji_54@2x.png',
  '[不要]': 'emoji_55@2x.png',
  '[举着]': 'emoji_56@2x.png',
  '[思考]': 'emoji_57@2x.png',
  '[猪头]': 'emoji_58@2x.png',
  '[不听]': 'emoji_59@2x.png',
  '[不看]': 'emoji_60@2x.png',
  '[不说]': 'emoji_61@2x.png',
  '[猴子]': 'emoji_62@2x.png',
  '[炸弹]': 'emoji_63@2x.png',
  '[睡觉]': 'emoji_64@2x.png',
  '[筋斗云]': 'emoji_65@2x.png',
  '[火箭]': 'emoji_66@2x.png',
  '[救护车]': 'emoji_67@2x.png',
  '[便便]': 'emoji_68@2x.png',
}
// var emoji = {
//   '[大笑]': 'icon-a-1',
//   '[开心]': 'icon-a-2',
//   '[色]': 'icon-a-3',
//   '[酷]': 'icon-a-4',
//   '[奸笑]': 'icon-a-5',
//   '[亲]': 'icon-a-6',
//   '[伸舌头]': 'icon-a-7',
//   '[眯眼]': 'icon-a-8',
//   '[可爱]': 'icon-a-9',
//   '[鬼脸]': 'icon-a-10',
//   '[偷笑]': 'icon-a-11',
//   '[喜悦]': 'icon-a-12',
//   '[狂喜]': 'icon-a-13',
//   '[惊讶]': 'icon-a-14',
//   '[流泪]': 'icon-a-15',
//   '[流汗]': 'icon-a-16',
//   '[天使]': 'icon-a-17',
//   '[笑哭]': 'icon-a-18',
//   '[尴尬]': 'icon-a-19',
//   '[惊恐]': 'icon-a-20',
//   '[大哭]': 'icon-a-21',
//   '[烦躁]': 'icon-a-22',
//   '[恐怖]': 'icon-a-23',
//   '[两眼冒星]': 'icon-a-24',
//   '[害羞]': 'icon-a-25',
//   '[睡着]': 'icon-a-26',
//   '[冒星]': 'icon-a-27',
//   '[口罩]': 'icon-a-28',
//   '[OK]': 'icon-a-29',
//   '[好吧]': 'icon-a-30',
//   '[鄙视]': 'icon-a-31',
//   '[难受]': 'icon-a-32',
//   '[不屑]': 'icon-a-33',
//   '[不舒服]': 'icon-a-34',
//   '[愤怒]': 'icon-a-35',
//   '[鬼怪]': 'icon-a-36',
//   '[发怒]': 'icon-a-37',
//   '[生气]': 'icon-a-38',
//   '[不高兴]': 'icon-a-39',
//   '[皱眉]': 'icon-a-40',
//   '[心碎]': 'icon-a-41',
//   '[心动]': 'icon-a-42',
//   '[好的]': 'icon-a-43',
//   '[低级]': 'icon-a-44',
//   '[赞]': 'icon-a-45',
//   '[鼓掌]': 'icon-a-46',
//   '[给力]': 'icon-a-47',
//   '[打你]': 'icon-a-48',
//   '[阿弥陀佛]': 'icon-a-49',
//   '[拜拜]': 'icon-a-50',
//   '[第一]': 'icon-a-51',
//   '[拳头]': 'icon-a-52',
//   '[手掌]': 'icon-a-53',
//   '[剪刀]': 'icon-a-54',
//   '[招手]': 'icon-a-55',
//   '[不要]': 'icon-a-56',
//   '[举着]': 'icon-a-57',
//   '[思考]': 'icon-a-58',
//   '[猪头]': 'icon-a-59',
//   '[不听]': 'icon-a-60',
//   '[不看]': 'icon-a-61',
//   '[不说]': 'icon-a-62',
//   '[猴子]': 'icon-a-63',
//   '[炸弹]': 'icon-a-64',
//   '[睡觉]': 'icon-a-65',
//   '[筋斗云]': 'icon-a-66',
//   '[火箭]': 'icon-a-67',
//   '[救护车]': 'icon-a-68',
//   '[便便]': 'icon-a-70',
// }


export default emoji
